





























import { Vue, Component, Prop } from 'vue-property-decorator';

import ErrorGradient from '@/components/icons/ErrorGradient.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';

@Component({
  components: {
    ErrorGradient,
    GhostButton,
    CloseModalIcon
  }
})
export default class CustomerImportFailure extends Vue {
  @Prop({ default: false }) modal?: boolean;

  get tPrefix() {
    return 'customerImport.failureModal';
  }
}
